__turbopack_context__.v({
  "circle": "styles-module__MswBxW__circle" + " " + "styles-module__MswBxW__shimmerStyles",
  "pill": "styles-module__MswBxW__pill" + " " + "styles-module__MswBxW__shimmerStyles",
  "placeholderShimmer": "styles-module__MswBxW__placeholderShimmer",
  "rectangle": "styles-module__MswBxW__rectangle" + " " + "styles-module__MswBxW__shimmerStyles",
  "shimmerStyles": "styles-module__MswBxW__shimmerStyles",
});
